import { DataTypeNames } from '../../enums';

export const checkIfInputIsNullable = dataType =>
  [DataTypeNames.Currency, DataTypeNames.Integer, DataTypeNames.Ratio, DataTypeNames.Date].includes(
    dataType,
  );
